import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../../../lib/i18next";
import Select from "../../../../../components/Form/Select";
import SelectBusinessAccount from "../../../../../components/Meta/SelectBusinessAccount";
import SelectTikTokIdentityCustom from "../../../../../components/Form/SelectTikTokIdentityCustom";
import SelectCatalogTikTok from "../../../../../components/Platforms/TikTok/Campaign/SelectCatalogTikTok";
import SelectAdvertisableAppsTikTok from "../../../../../components/Platforms/TikTok/AdGroup/SelectAdvertisableAppsTikTok";
import SelectTrackingIDField from "../../../../../components/Form/SelectTrackingIDField";
import Typography from "@mui/material/Typography";
import {
  optionsAdsCampaignAppPromotionTypesTikTok,
  optionsAdsCampaignObjectivesTikTok,
  optionsAdsSalesCampaignTypeTikTok,
  optionsAppPromotion,
} from "../../../../../utils/options";
import {
  ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_WEBSITE_OPTION,
  TIKTOK,
} from "../../../../../utils/constants";
import {
  AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  CATALOG_PLACEHOLDER,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL,
  IDENTITY_TIK_TOK_PLACEHOLDER,
  SELECT_A_OPTION,
  TRACKING_TIKTOK_ID_PLACEHOLDER,
} from "../../../../../i18n/keysTranslations";
import { getTikTokDefaultsFieldVisibility } from "../../../../../utils/platformDefaults/platformDefaultsFieldVisibility";
import { PLATFORM_DEFAULTS_FIELD_LABEL_SX } from "../../../../../utils/platformDefaults/platformDefaultsFieldLabelSx";

const PlatformDefaultsFormTikTok = ({ formMethods }) => {
  const { t } = useTranslationApp();
  const { control, setValue, watch } = formMethods;

  const objective = watch("objective");
  const type = watch("type");
  const integrationID = watch("integrationID");
  const adAccountID = watch("adAccountID");

  const visibility = getTikTokDefaultsFieldVisibility({ objective, type });

  const typeOptions =
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION
      ? optionsAdsSalesCampaignTypeTikTok
      : optionsAdsCampaignAppPromotionTypesTikTok;

  const typeTitleKey =
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION
      ? CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL
      : CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {visibility.objective ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL)}
          </Typography>
          <Select
            options={optionsAdsCampaignObjectivesTikTok}
            name="objective"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
            actionsChange={(value) => {
              setValue("identityTikTokID", "");
              if (value === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION) {
                setValue(
                  "type",
                  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_WEBSITE_OPTION
                );
              } else if (
                value === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION
              ) {
                setValue("type", "");
              }
            }}
          />
        </Box>
      ) : null}

      {visibility.type ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(typeTitleKey)}
          </Typography>
          <Select
            options={typeOptions}
            name="type"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
            actionsChange={() => {
              setValue("identityTikTokID", "");
              setValue("catalogID", "");
            }}
          />
        </Box>
      ) : null}

      {visibility.appPromotion ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL)}
          </Typography>
          <Select
            options={optionsAppPromotion}
            name="appPromotion"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
            actionsChange={(value) => {
              setValue(
                "isIOS14Campaign",
                value === ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION
              );
            }}
          />
        </Box>
      ) : null}

      {visibility.identities ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL)}
          </Typography>
          <SelectBusinessAccount
            variant="filled"
            label={t(AD_ACCOUNT_TIKTOK_PLACEHOLDER)}
            control={control}
            platform={TIKTOK}
            name="adAccountID"
            onChangeAction={(value) => {
              setValue("integrationID", value?.integrationID);
              setValue("identityTikTokID", "");
              setValue("catalogID", "");
            }}
            fullWidth={true}
          />
          <SelectTikTokIdentityCustom
            variant="filled"
            objective={objective}
            type={type}
            label={t(IDENTITY_TIK_TOK_PLACEHOLDER)}
            control={control}
            integrationID={integrationID}
            adAccountID={adAccountID}
            name="identityTikTokID"
            fullWidth={true}
          />
        </Box>
      ) : null}

      {visibility.appID ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL)}
          </Typography>
          <SelectAdvertisableAppsTikTok
            placeholder={t(SELECT_A_OPTION)}
            platform={TIKTOK}
            adAccountID={adAccountID}
            integrationID={integrationID}
            name="appID"
            fullWidth
            variant="filled"
            control={control}
          />
        </Box>
      ) : null}

      {visibility.catalogID ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL)}
          </Typography>
          <SelectCatalogTikTok
            control={control}
            name="catalogID"
            label={t(CATALOG_PLACEHOLDER)}
            fullWidth
            variant="filled"
            integrationID={integrationID}
            adAccountID={adAccountID}
          />
        </Box>
      ) : null}

      {visibility.trackingID ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(TRACKING_TIKTOK_ID_PLACEHOLDER)}
          </Typography>
          <SelectTrackingIDField
            control={control}
            name="trackingID"
            label={t(SELECT_A_OPTION)}
            fullWidth
            variant="filled"
            platform={TIKTOK}
            integrationID={integrationID}
            adAccountID={adAccountID}
            rules={{}}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default PlatformDefaultsFormTikTok;
